// ============================================================
// Entry point React 18
// Antes de renderizar, carga site-config para aplicar la marca
// (colores, título, favicon) y evitar el "parpadeo" de colores.
// ============================================================
import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './styles/globals.css'
import { applyBranding, resolveBranding } from '@/utils/brand'
import { SITE_CONFIG_KEY, fetchSiteConfig, useSiteConfig } from '@/hooks/useSiteConfig'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:           1000 * 60 * 5,
      gcTime:              1000 * 60 * 10,
      retry:               2,
      refetchOnWindowFocus: false,
    },
  },
})

/** Re-aplica la marca cada vez que cambia site-config (p. ej. al guardar desde el admin). */
function BrandingSync() {
  const { data } = useSiteConfig()
  useEffect(() => {
    if (data) applyBranding(resolveBranding(data.branding))
  }, [data])
  return null
}

async function bootstrap() {
  try {
    const config = await fetchSiteConfig()
    queryClient.setQueryData(SITE_CONFIG_KEY, config)
    applyBranding(resolveBranding(config?.branding))
  } catch {
    // Si la API no responde, la tienda arranca con los colores por defecto
  }

  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrandingSync />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>
  )
}

bootstrap()
